function leg_initialize_autocomplete_form(form) {
	var input = $('input[name="address"]', form)[0];
	var options = {
		componentRestrictions: {
			country: 'us'
		}
	};
	var autocomplete = new google.maps.places.Autocomplete(input, options);
	autocomplete.addListener('place_changed', function() {
		var place = autocomplete.getPlace();
		var lat = place.geometry.location.lat();
		var lng = place.geometry.location.lng();
		// convert offset to seconds
		var offset = place.utc_offset_minutes * 60;
		$(input).attr('data-latitude', lat).attr('data-longitude', lng).attr('data-offset', offset);
	});
}

function leg_submit_autocomplete_form(form) {
	$(form).submit(function(e) {
		e.preventDefault();

		$('.button-spinner', form).prop('disabled', true);

		var type = 'hourly';

		var input = $('input[name="address"]', form);

		var address = $(input).val();
		var lat = $(input).attr('data-latitude');
		var lng = $(input).attr('data-longitude');
		var offset = $(input).attr('data-offset');
		var nonce = $('#autocomplete-form-nonce').val();

		if (lat === 0 && lng === 0) {
			// nothing selected, throw an error
			$('.button-spinner', form).prop('disabled', false);
			return false;
		}

		var date = new Date();
		$.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'initial_search_query',
				parkingType: type,
				address: address,
				latitude: lat,
				longitude: lng,
				startTime: GetTimeNearest30(date),
				startDate: GetDateStr(date),
				offset: offset,
				nonce: nonce
			},
			success: function (results) {
				var results = $.parseJSON(results);
				console.log(results);
				if (results.status == 'success') {
					if (results.match == true) {
						var url = new URL(results.location.permalink);
						url.searchParams.set('type', results.parkingType);
						window.location.href = url.href;
					} else {
						var url = new URL(window.location.href);
						url.pathname = '/search/';
						url.searchParams.set('type', results.parkingType);
						url.searchParams.set('startDate', GetDateStr(date));
						url.searchParams.set('startTime', GetTimeNearest30(date));
						url.searchParams.set('lat', results.latitude);
						url.searchParams.set('lng', results.longitude);
						url.searchParams.set('address', encodeURIComponent(results.address));
						url.searchParams.set('offset', results.offset);
						console.log('url:', url);
						window.location.href = url.href;
					}
				} else {
					console.log('error!', results.message);
					$('.button-spinner').prop('disabled', false);
				}
			},
			error: function (results) {
				var results = $.parseJSON(results);
				console.log(results);
				$('.button-spinner').prop('disabled', false);
			}
		});

	});
}

function leg_close_modal(modal) {
	$(modal).addClass('leg-modal-closing');
	setTimeout(function() {
		$(modal).remove();
		$('body').removeClass('leg-modal-active');
	}, 750);
}

$(document).ready(function() {

	$('.leg-find-parking-form').each(function(index, form) {
		leg_initialize_autocomplete_form(form);
		leg_submit_autocomplete_form(form);
	});

	// tabs functionality
	$('.leg-block-tabs-group').each(function(index, tabs) {
		$('.leg-tabs-menu-item', tabs).on('click', function(e) {
			e.preventDefault();
			const tab_name = $(this).attr('data-tab');
			$('.leg-tabs-menu-item', tabs).removeClass('leg-tabs-menu-item-active');
			$(this).addClass('leg-tabs-menu-item-active');
			$('.leg-tab', tabs).removeClass('leg-tab-active');
			$('.leg-tab[data-tab="' + tab_name + '"]').addClass('leg-tab-active');
		});
	});

	// open/close faq questions
	$('.leg-faq-question').on('click', function() {
		$(this).parent().toggleClass('leg-faq-active');
	});

	// launch team member modal
	$('.leg-team-member').on('click', function() {
		const id = $(this).attr('data-id');
		$.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'leg_get_team_member',
				id: id
			},
			success: function(results) {
				results = JSON.parse(results);
				console.log(results);
				if (results.status === 'success') {
					const data = results.data;
					const modal = $($('#leg-modal-template').html());
					if (data.image) {
						const image = $('<img />').attr({
							src: data.image.url,
							srcset: data.image.url + ', ' + data.image.url + ' 2x',
							alt: data.image.alt
						});
						$('.leg-modal-image', modal).append(image);
					}
					if (data.title) {
						$('.leg-modal-title', modal).html(data.title);
					} else {
						$('.leg-modal-title', modal).remove();
					}
					if (data.job_title) {
						$('.leg-modal-meta', modal).html(data.job_title);
					} else {
						$('.leg-modal-meta', modal).remove();
					}
					if (data.biography) {
						$('.leg-modal-text', modal).html(data.biography);
					} else {
						$('.leg-modal-text', modal).remove();
					}
					if (data.social_media) {
						if (data.social_media.facebook_url) {
							const facebook = $('<a></a>').html('<svg width="24" height="24" version="2.0"><use href="#icon-facebook" /></svg><span class="visually-hidden">Follow ' + data.title + ' on Facebook</span>').attr({
								href: data.social_media.facebook_url,
								target: '_blank',
								title: 'Follow ' + data.title + ' on Facebook'
							});
							$('.leg-modal-social-media-menu', modal).append(facebook);
						}
						if (data.social_media.twitter_handle) {
							const twitter = $('<a></a>').html('<svg width="24" height="24" version="2.0"><use href="#icon-twitter" /></svg><span class="visually-hidden">Follow ' + data.title + ' on Twitter</span>').attr({
								href: 'https://twitter.com/' + data.social_media.twitter_handle,
								target: '_blank',
								title: 'Follow ' + data.title + ' on Twitter'
							});
							$('.leg-modal-social-media-menu', modal).append(twitter);
						}
						if (data.social_media.instagram_handle) {
							const instagram = $('<a></a>').html('<svg width="24" height="24" version="2.0"><use href="#icon-instagram" /></svg><span class="visually-hidden">Follow ' + data.title + ' on Instagram</span>').attr({
								href: 'https://instagram.com/' + data.social_media.instagram_handle,
								target: '_blank',
								title: 'Follow ' + data.title + ' on Instagram'
							});
							$('.leg-modal-social-media-menu', modal).append(instagram);
						}
						if (data.social_media.linkedin_url) {
							const linkedin = $('<a></a>').html('<svg width="24" height="24" version="2.0"><use href="#icon-linkedin" /></svg><span class="visually-hidden">Follow ' + data.title + ' on LinkedIn</span>').attr({
								href: data.social_media.linkedin_url,
								target: '_blank',
								title: 'Follow ' + data.title + ' on LinkedIn'
							});
							$('.leg-modal-social-media-menu', modal).append(linkedin);
						}
					} else {
						$('.leg-modal-social-media-menu', modal).remove();
					}
					$('body').addClass('leg-modal-active').append(modal);
				}
			},
			error: function(results) {
				console.log(results);
			}
		});
	});

	// close team member modal on button click
	$('body').on('click', '.leg-modal-close', function(e) {
		e.preventDefault();
		leg_close_modal($('.leg-modal'));
	});

	// close modal on ESC key press
	$(document).on('keydown', function(e) {
		if (e.keyCode === 27) {
			leg_close_modal($('.leg-modal'));
		}
	});

	// count statistics up from zero
	if ($('.leg-block-statistics-group').length > 0) {
		$('.leg-block-statistics-group').each(function(index, group) {
			var statistics = $('.leg-block-statistic', group);
			$(statistics).each(function(index, statistic) {
				var target = $('.leg-block-statistic-number', statistic)[0];
				var end_number = $(target).attr('data-number');
				var prefix = $(target).attr('data-prefix');
				var suffix = $(target).attr('data-suffix');
				var options = {
					startVal: 0,
					decimalPlaces: 0,
					duration: 5,
					useGrouping: true,
					useEasing: true,
					prefix: prefix,
					suffix: suffix,
					enableScrollSpy: true,
					scrollSpyOnce: true
				};
				var counter = new CountUp(target, end_number, options);
			});
		});
	}

	// services card carousel
	$('.leg-service-cards-wrapper').each(function(index, wrapper) {
		var wrapper_class = $(wrapper).attr('class');
		var slider = $('.leg-service-cards-group', wrapper).flickity({
			adaptiveHeight: false,
			autoPlay: true,
			cellAlign: 'center',
			contain: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
		slider.on('change.flickity', function(event, index) {
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + index + '"]', wrapper).addClass('active');
		});
		$('.leg-custom-slider-pager-item', wrapper).on('click', function(e) {
			e.preventDefault();
			var index = $(this).attr('data-slide-index');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$(this).addClass('active');
			slider.flickity('select', index, true, false);
		});
		$('.leg-custom-slider-button-prev', wrapper).on('click', function(e) {
			e.preventDefault();
			slider.flickity('previous', true, false);
			var data = slider.data('flickity');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + data.selectedIndex + '"]', wrapper).addClass('active');
		});
		$('.leg-custom-slider-button-next', wrapper).on('click', function(e) {
			e.preventDefault();
			slider.flickity('next', true, false);
			var data = slider.data('flickity');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + data.selectedIndex + '"]', wrapper).addClass('active');
		});
	});

	// case study card carousel
	$('.leg-case-studies-cards-wrapper').each(function(index, wrapper) {
		var wrapper_class = $(wrapper).attr('class');
		var pager_custom_selector = '.' + wrapper_class + ' .leg-custom-slider-pager';
		var slider = $('.leg-case-studies-cards-group', wrapper).flickity({
			adaptiveHeight: false,
			cellAlign: 'center',
			contain: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
		slider.on('change.flickity', function(event, index) {
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + index + '"]', wrapper).addClass('active');
		});
		$('.leg-custom-slider-pager-item', wrapper).on('click', function(e) {
			e.preventDefault();
			var index = $(this).attr('data-slide-index');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$(this).addClass('active');
			slider.flickity('select', index, true, false);
		});
		$('.leg-custom-slider-button-prev', wrapper).on('click', function(e) {
			e.preventDefault();
			slider.flickity('previous', true, false);
			var data = slider.data('flickity');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + data.selectedIndex + '"]', wrapper).addClass('active');
		});
		$('.leg-custom-slider-button-next', wrapper).on('click', function(e) {
			e.preventDefault();
			slider.flickity('next', true, false);
			var data = slider.data('flickity');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + data.selectedIndex + '"]', wrapper).addClass('active');
		});
	});

	// app features images and content carousels
	$('.leg-app-features-wrapper').each(function(index, wrapper) {
		var wrapper_class = $(wrapper).attr('class');
		var pager_custom_selector = '.' + wrapper_class + ' .leg-custom-slider-pager';
		var content_slider = $('.leg-app-features-contents-group', wrapper).flickity({
			adaptiveHeight: true,
			cellAlign: 'center',
			contain: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
		var images_slider = $('.leg-app-features-images-group', wrapper).flickity({
			adaptiveHeight: false,
			cellAlign: 'center',
			contain: true,
			draggable: false,
			fade: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
		content_slider.on('change.flickity', function(event, index) {
			images_slider.flickity('select', index, true, false);
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + index + '"]', wrapper).addClass('active');
		});
		$('.leg-custom-slider-pager-item', wrapper).on('click', function(e) {
			e.preventDefault();
			var index = $(this).attr('data-slide-index');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$(this).addClass('active');
			content_slider.flickity('select', index, true, false);
			images_slider.flickity('select', index, true, false);
		});
		$('.leg-custom-slider-button-prev', wrapper).on('click', function(e) {
			e.preventDefault();
			content_slider.flickity('previous', true, false);
			images_slider.flickity('previous', true, false);
			var data = content_slider.data('flickity');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + data.selectedIndex + '"]', wrapper).addClass('active');
		});
		$('.leg-custom-slider-button-next', wrapper).on('click', function(e) {
			e.preventDefault();
			content_slider.flickity('next', true, false);
			images_slider.flickity('next', true, false);
			var data = content_slider.data('flickity');
			$('.leg-custom-slider-pager-item', wrapper).removeClass('active');
			$('.leg-custom-slider-pager-item[data-slide-index="' + data.selectedIndex + '"]', wrapper).addClass('active');
		});
	});

	// slideshow block functionality
	if ($('.leg-block-slideshow').length > 0) {
		$('.leg-block-slideshow').each(function(index, slideshow) {
			var slides = $('.leg-block-slideshow-item', slideshow);
			if ($(slides).length > 1) {
				var slider = $('.leg-block-slideshow-items-group').flickity({
					adaptiveHeight: false,
					autoPlay: 2000,
					cellAlign: 'left',
					contain: true,
					pageDots: false,
					percentPosition: true,
					prevNextButtons: false,
					wrapAround: true
				});
			}
		});
	}

});
